import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Anonymous gift certificate balance check.
 *
 * Public page: no auth, no studio context. Talks straight to the anonymous
 * balance endpoint, which is flood-limited server-side and returns a uniform
 * not-found for anything that isn't a clean hit, so this page can stay dumb:
 * one input, one result card, no error taxonomy.
 */
@Component({
  selector: 'app-gift-certificate-balance',
  templateUrl: './gift-certificate-balance.component.html',
  styleUrls: ['./gift-certificate-balance.component.css']
})
export class GiftCertificateBalanceComponent implements OnInit {
  code = '';
  pending = false;
  result: any = null;

  constructor(private http: HttpClient, private route: ActivatedRoute) { }

  /** The texted certificate links here with ?code=, so look it up on arrival. */
  ngOnInit() {
    const code = (this.route.snapshot.queryParamMap.get('code') || '').trim();
    if (code) {
      this.code = code.toUpperCase();
      this.checkBalance();
    }
  }

  checkBalance() {
    const code = (this.code || '').trim().toUpperCase();
    if (!code) {
      return;
    }

    this.pending = true;
    this.result = null;

    this.http.post(`${environment.hostUrl}/api/v1/gift-certificates/balance`, { code })
      .subscribe(
        (response: any) => {
          this.pending = false;
          this.result = response;
        },
        (error) => {
          this.pending = false;
          this.result = error?.status === 429
            ? { found: false, error: 'Too many lookups. Please try again later.' }
            : { found: false };
        }
      );
  }
}
